export default class SubUser {
  constructor() {
    this.id = null;
    this.email = null;
    this.password = null;
    this.role = null;
    this.editing = true;
    this.view_payouts = false;
    this.request_payouts = false;
    this.access_domains = false;
    this.allowed_domains = [];
  }
};

export class TierInfo {
  constructor(name, units, discount, price) {
    this.name = name;
    this.units = units;
    this.discount = discount;
    this.price = price;
  }
};